
import { DocumentPopupComponent } from './documentPopup.component';
import { DocumentPopupService } from './documentPopup.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiriusAngularDocumentviewerModule } from '@ibtech/sirius-angular-documentviewer';

@NgModule({
    imports: [ 
    CommonModule,
    SiriusAngularDocumentviewerModule
    ],
    declarations: [
        DocumentPopupComponent
    ],
    providers: [DocumentPopupService],
    exports: [
        DocumentPopupComponent
    ]
})
export class DocumentPopupModule { }
